import { SpecialZones, ZoomableWrapper } from '@hakimo-ui/hakimo/ui-elements';
import { useRerenderOnWindowResize } from '@hakimo-ui/shared/ui-base';
import { useAlarmGroupCamera } from '../alarm-provider/AlarmGroupProvider';
import FramesMedia from './FramesMedia';
import { VideoMedia } from './VideoMedia';

interface Props {
  alarmId: string;
  isPlaying: boolean;
  isCurrentAlarm: boolean;
  specialZones?: SpecialZones;
}

export function AlarmMedia(props: Props) {
  const { alarmId, isPlaying, isCurrentAlarm, specialZones } = props;
  const { alarmToDetailsMap } = useAlarmGroupCamera();
  const alarmDetails = alarmToDetailsMap[alarmId];
  useRerenderOnWindowResize();

  if (!alarmDetails) {
    return null;
  }
  const {
    media: { type: mediaType, frames },
  } = alarmDetails;

  const isFrames = mediaType === 'frames';

  return (
    <div className="relative h-full max-h-full w-full rounded-md">
      <ZoomableWrapper controlsTopOffset={isFrames ? '1.25rem' : '0'}>
        {mediaType === 'video' && (
          <VideoMedia
            alarmId={alarmId}
            isPlaying={isPlaying}
            isCurrentAlarm={isCurrentAlarm}
            specialZones={specialZones}
          />
        )}
        {isFrames &&
          (Array.isArray(frames) && frames.length > 0 ? (
            <FramesMedia frames={frames} specialZones={specialZones} />
          ) : (
            <div className="text-ondark-text-1 absolute inset-0 flex items-center justify-center text-sm">
              No frames available
            </div>
          ))}
      </ZoomableWrapper>
    </div>
  );
}

export default AlarmMedia;
